import {PartnerType} from "./partnerType";

export class Partner {
    public id: string;
    public email: string;
    public name: string;
    public phone: string;
    public cp: string;
    public city: string;
    public address: string;
    public contactPerson: string;
    public created: Date;
    public createdBy: number;
    public partnerTypeId: string;
    public type: PartnerType;
}



// WEBPACK FOOTER //
// ./src/classes/partner.ts